import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import { isYoutubeVideo, makePlaylistForJWPlayer } from "../../utils/helper";
import YoutubeEmbed from "../../containers/loggedIn/Feed/common/YoutubeEmbed";
import ChevronRight from "../../assets/images/photos/chevron-right.svg";
import ProductPlaceholder from "../../assets/images/products/product-placeholder.svg";
import { screenBreakpoints } from "../../utils/commonVariables";
import CommonPlayer from "../CommonPlayer";
const sliderSettings = {
  dots: false,
  infinite: false,
  prevArrow: <SliderArrow to="prev" />,
  nextArrow: <SliderArrow to="next" />,
  responsive: [
    {
      breakpoint: screenBreakpoints.tab,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function SliderArrow(props) {
  const { onClick, to, currentSlide, slideCount } = props,
    isDisabled =
      (to === "prev" && currentSlide === 0) ||
      (to === "next" && currentSlide === slideCount - 1);
  return (
    <button
      aria-hidden="true"
      aria-disabled={isDisabled}
      type="button"
      disabled={isDisabled}
      className={`product__media__arrow product__media__arrow--${to} ${
        isDisabled ? "product__media__arrow--disabled" : ""
      }`}
      onClick={onClick}
    >
      <img
        className={`product__media__arrow__icon product__media__arrow__icon--${to}`}
        src={ChevronRight}
        alt="go to next slide"
      />
    </button>
  );
}

const ProductImageMedia = ({ image }) => {
  return (
    <div className="product__media__item">
      <img src={image.original_photo} alt="product" />
    </div>
  );
};

const ProductVideoMedia = ({ youtubeId }) => {
  return (
    <div className="product__media__item product__media__item--video">
      <YoutubeEmbed youtubeId={youtubeId} />
    </div>
  );
};

const ProductSystemVideoMedia = ({ mediaJson, videosMeta, id }) => {
  return (
    <CommonPlayer
      videosMeta={videosMeta}
      playerId={`publicr-${id}`}
    />
  );
};

function ProductMedia({ images, video, videosMeta, assetOrder }) {
  if (!images.length && !video && !videosMeta.length)
    return (
      <div className="product__media__item">
        <img src={ProductPlaceholder} alt="product" />
      </div>
    );
  const imagesList = images.length
    ? images.map((image, imageIndex) => (
        <ProductImageMedia key={`product ${imageIndex}`} image={image} />
      ))
    : null;
  const videoLink =
    video && isYoutubeVideo(video) ? (
      <ProductVideoMedia youtubeId={isYoutubeVideo(video)} />
    ) : null;
  const isMediaJson =
    videosMeta && videosMeta.length && videosMeta[0] && videosMeta[0].media_json
      ? videosMeta[0].media_json
      : false;
  return (
    <Slider {...sliderSettings}>
      {assetOrder.map((val, index) => {
        if (val == "videos") {
          return video && isYoutubeVideo(video) ? (
            videoLink
          ) : videosMeta &&
            videosMeta.length &&
            videosMeta[0] &&
            videosMeta[0].media_json ? (
            <ProductSystemVideoMedia
              mediaJson={isMediaJson}
              videosMeta={videosMeta}
              id={videosMeta[0].timestamp}
            />
          ) : null;
        } else {
          return imagesList;
        }
      })}
    </Slider>
  );
}

ProductMedia.propTypes = {
  images: PropTypes.array,
  video: PropTypes.string,
};

export default ProductMedia;
